export default __webpack_public_path__ + "static/media/profiler.e87b80c7.png";